import type { TableHeaderRow } from '@shared/table-generator';

import { MINIMUM_DISPLAY_CHOICE } from '../../constants';
export function ItemAnalysisDiscriminantTableHeader(choice: number): TableHeaderRow[] {
  const choiceNumber = choice === 0 ? MINIMUM_DISPLAY_CHOICE : choice;
  return [
    {
      children: [
        {
          id: 'no',
          children: 'No.',
          align: 'center',
          rowSpan: 2,
          width: 64,
        },
        {
          id: 'questionId',
          children: 'QID',
          align: 'center',
          rowSpan: 2,
          width: 200,
        },
        {
          id: 'answer',
          children: 'Answer',
          align: 'center',
          rowSpan: 2,
          width: 100,
        },
        {
          id: 'numberPass',
          children: 'Number of Pass (คน)',
          align: 'center',
          colSpan: choiceNumber + 1,
        },
        {
          id: 'numberFail',
          children: 'Number of Fail (คน)',
          align: 'center',
          colSpan: choiceNumber + 1,
        },
        {
          id: 'bIndex',
          children: 'B-Index',
          align: 'center',
          rowSpan: 2,
          width: 100,
        },
      ],
    },

    {
      children: Array.from({ length: choiceNumber }, (_, i) => ({
        id: `passS${i}`,
        children: `S${i}`,
        align: 'center' as const,
        width: 90,
      })).concat(
        {
          id: 'spacerNP',
          children: 'NP',
          align: 'center' as const,
          width: 90,
        },
        Array.from({ length: choiceNumber }, (_, i) => ({
          id: `failS${i}`,
          children: `S${i}`,
          align: 'center' as const,
          width: 90,
        })),
        {
          id: 'spacerNF',
          children: 'NF',
          align: 'center' as const,
          width: 90,
        },
      ),
    },
  ];
}
